import { Box, Typography } from "@mui/material";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { floor } from "ramda-adjunct";
import { differenceIn } from "@sinch/utils/dateTime/dateFns";
import { useWorker } from "../../Worker/hooks";
import { StaffHeaderFragment } from "./fragments.types";

/**
 * Worker name with an optional age badge. The last word of the name is kept on the
 * same line as the age (`white-space: nowrap`) so the age never wraps on its own.
 */
export const StaffName: FC<{ staff: StaffHeaderFragment }> = ({ staff }) => {
  const { t } = useTranslation();
  const { getWorkerName } = useWorker();

  const workerName = getWorkerName(staff);
  const lastSpace = workerName.trimEnd().lastIndexOf(" ");
  const [nameFirst, nameSecond] =
    lastSpace === -1 ? ["", workerName] : [workerName.slice(0, lastSpace), workerName.slice(lastSpace + 1)];

  return (
    <Typography sx={{ display: "inline-block", fontSize: "17px", fontWeight: 500, lineHeight: "20px" }}>
      {nameFirst}{" "}
      <Box sx={{ display: "inline", whiteSpace: "nowrap" }}>
        {nameSecond}{" "}
        {staff.birthdate && (
          <Typography variant="descriptionTiny">
            {t("years", { years: floor(differenceIn("years")(new Date(), staff.birthdate)) })}
          </Typography>
        )}
      </Box>
    </Typography>
  );
};
